import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { INSTAGRAM, SHOP_URL } from "@/lib/shop";
import { LINKS } from "./Nav";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#1B1530] text-white pt-20 pb-28 md:pb-12">
    <div className="max-w-[1400px] mx-auto px-4 sm:px-8">
      <div className="flex flex-wrap items-start justify-between gap-10">
        <img src="/img/logo-new.webp" alt="Swole Bears" data-testid="footer-logo" className="h-20 sm:h-24 w-auto" />
        <div className="grid grid-cols-2 gap-x-12 gap-y-3 text-sm">
          {LINKS.map(([to, label]) => <Link key={to} to={to} data-testid={`footer-link-${to.slice(1)}`} className="text-white/80 hover:text-[#3EE6FF] transition-colors">{label}</Link>)}
          <a data-testid="footer-instagram-link" href={INSTAGRAM} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-white/80 hover:text-[#3EE6FF] transition-colors"><Instagram className="h-4 w-4" /> Instagram</a>
          <a data-testid="footer-account-link" href={`${SHOP_URL}/account`} className="text-white/80 hover:text-[#3EE6FF] transition-colors">My account</a>
        </div>
      </div>
      <p className="font-display text-[18vw] lg:text-[11rem] leading-[0.8] mt-16 text-white/[0.07] select-none">Get Swole.</p>
      <div className="mt-8 flex flex-wrap justify-between gap-4 text-xs text-white/70 font-semibold uppercase tracking-[0.14em]">
        <span>© 2026 Swole Bears · Made in Nova Scotia</span>
        <span>Founded by Rory Fox at 14</span>
      </div>
    </div>
  </footer>
);
